import { NavLink, Link, useLocation } from "react-router-dom";

export default function Nav() {
  const { pathname } = useLocation();
  const isActive = (p) => (pathname === p ? "active" : "");

  return (
    <nav className="nav" data-testid="main-nav">
      <div className="container nav-inner">
        <Link to="/" className="logo" data-testid="logo-link">
          Berenice <span className="accent">Sin Filtro</span>
        </Link>
        <ul className="nav-links">
          <li>
            <NavLink to="/escritos" className={isActive("/escritos")} data-testid="nav-escritos">
              Escritos
            </NavLink>
          </li>
          <li>
            <a href="/#temas" data-testid="nav-temas">Temas</a>
          </li>
          <li>
            <NavLink to="/sobre-mi" className={isActive("/sobre-mi")} data-testid="nav-sobre-mi">
              Sobre mí
            </NavLink>
          </li>
          <li>
            <NavLink to="/newsletter" className={isActive("/newsletter")} data-testid="nav-newsletter">
              Newsletter
            </NavLink>
          </li>
        </ul>
        <Link to="/newsletter" className="btn btn-primary btn-sm" data-testid="nav-cta-suscribirse">
          Suscribirse
          <span aria-hidden="true">→</span>
        </Link>
      </div>
    </nav>
  );
}
